import React from 'react';
import { useIsTablet } from '@guildeducationinc/catalog-tools';
import { CatalogFeedbackWidget } from '@src/components/CatalogFeedbackWidget';
import { ResultsPagination } from '@src/components/CustomPagination';
import { FacetsInputTagList } from '@src/components/FacetsInputTagList';
import { ResultCount } from '@src/components/ResultCount';
import { ResultsList } from '@src/components/ResultsList';
import { DesktopFilters, MobileFilters } from 'src/components/Filters';
import { SearchBar } from '@src/components/SearchBar/SearchBar';
import { ShelfBanner } from '@src/components/ShelfBanner';
import { SEO } from '@src/components/SEO';
import { Typography } from '@guildeducationinc/recess';
import styles from './SearchContainer.module.scss';

export const SearchContainer: React.FC = () => {
	const isTablet = useIsTablet();

	return (
		<>
			<div className={styles.searchContainer}>
				<SEO path={location.pathname} title='Programs' />
				<ShelfBanner />
				<Typography className={styles.searchHeader} variant='h2'>
					Search all programs
				</Typography>
				<SearchBar />
				<div className='flex'>
					<DesktopFilters />
					<div className={styles.searchSectionContainer}>
						{isTablet && <MobileFilters />}
						<ResultCount />
						<FacetsInputTagList />
						<ResultsList />
						<ResultsPagination />
						<CatalogFeedbackWidget />
					</div>
				</div>
			</div>
		</>
	);
};
